import React from 'react';
import { Link } from 'react-router-dom';
import './CityGrid.css';

export default function CityGrid({ cities, stateName, stateSlug }) {
    return (
        <section className="city-section">
            <div className="city-container">
                <div className="city-header">
                    <h2 className="city-title">Cities in {stateName}</h2>
                    <p className="city-subtitle">Select a city to explore local businesses</p>
                </div>

                <div className="city-grid">
                    {cities.map((city) => (
                        <Link key={city.id} to={`/in/${stateSlug}/${city.slug}`} className="city-card">
                            <div className="city-info">
                                <div className="city-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M3 21h18" />
                                        <path d="M5 21V7l8-4 8 4v14" />
                                        <path d="M8 21v-2a2 2 0 0 1 4 0v2" />
                                    </svg>
                                </div>
                                <span className="city-name">{city.name}</span>
                            </div>
                            <svg
                                className="city-arrow"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M5 12h14M12 5l7 7-7 7" />
                            </svg>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
